import { useContext } from 'react'
import { GitContext } from './GitContext'

const useGitContext = () => useContext(GitContext)

export default useGitContext
